import { render, staticRenderFns } from "./takeClothes.vue?vue&type=template&id=bce709ee&scoped=true"
import script from "./takeClothes.vue?vue&type=script&lang=js"
export * from "./takeClothes.vue?vue&type=script&lang=js"
import style0 from "./takeClothes.vue?vue&type=style&index=0&id=bce709ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce709ee",
  null
  
)

export default component.exports